/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { array as codecArray } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseRubricRow } from './BaseRubricRow';
import { RubricRowItem } from './RubricRowItem';
const DiscreteRubricRowParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('discrete')],
    ['items', /* #__PURE__ */ codecArray(RubricRowItem)],
]), BaseRubricRow);
export class DiscreteRubricRow extends BaseRubricRow {
    static decode(input) {
        return DiscreteRubricRowParser.decode(input).map(res => new DiscreteRubricRow(res));
    }
    static unsafeDecode(input) {
        return DiscreteRubricRow.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DiscreteRubricRowParser.encode(data);
    }
    static schema() {
        return DiscreteRubricRowParser.schema();
    }
}
